<template>
  <div class="secondary-btn-container" v-bind:class="rootClassName">
    <button class="secondary-btn-button button">{{ button }}</button>
  </div>
</template>

<script>
export default {
  name: 'SecondaryBtn',
  props: {
    button: {
      type: String,
      default: 'Button',
    },
    rootClassName: String,
  },
}
</script>

<style scoped>
.secondary-btn-container {
  display: flex;
  position: relative;
}
.secondary-btn-button {
  color: var(--dl-color-gray-white);
  border: none;
  padding-top: var(--dl-space-space-halfunit);
  padding-left: var(--dl-space-space-doubleunit);
  border-radius: 50px;
  padding-right: var(--dl-space-space-doubleunit);
  padding-bottom: var(--dl-space-space-halfunit);
  background-color: var(--dl-color-primary-100);
}

.secondary-btn-root-class-name1 {
  align-self: center;
  margin-top: 1.5rem;
}
.secondary-btn-root-class-name2 {
  align-self: center;
  margin-top: 1.5rem;
}

</style>
